import { gridSize } from '@/shared';
import {
  FormControl,
  Grid,
  MenuItem,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { FieldError } from 'react-hook-form';

export type ModelStateSelectProps = {
  label?: string;
  required?: boolean;

  register: TextFieldProps;
  defaultValue: string | number | boolean;
  textFieldKey?: string | number | boolean;
  error: FieldError | undefined;
  helperText: React.ReactNode;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  label1?: string;
  label2?: string;
  disabled?: boolean;
};

const ModelStateSelect: React.FC<ModelStateSelectProps> = ({
  error,
  textFieldKey,
  defaultValue,
  helperText,
  label = 'Estado',
  register,
  size = gridSize,
  required = true,
  label1 = 'Activo',
  label2 = 'Inactivo',
  disabled = false,
}) => {
  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <TextField
          key={(textFieldKey || defaultValue) as any}
          select
          label={label}
          variant="outlined"
          fullWidth
          defaultValue={defaultValue}
          {...register}
          error={!!error}
          helperText={helperText}
          required={required}
          disabled={disabled}
        >
          <MenuItem value={'1'}>{label1}</MenuItem>
          <MenuItem value={'0'}>{label2}</MenuItem>
        </TextField>
      </FormControl>
    </Grid>
  );
};

export default ModelStateSelect;
